import React from 'react';
import { AuditLogTable } from '@hofsync/design-system';
import { useAuditEvents } from '../../../hooks/useAuditEvents';
import './DocumentHistorySection.css';

interface DocumentHistorySectionProps {
  docId: string;
}

const SKELETON_ROWS = 4;

const DocumentHistorySection: React.FC<DocumentHistorySectionProps> = ({ docId }) => {
  const { entries, isLoading, isError, refetch } = useAuditEvents({
    scope: { object_type: 'document', object_id: docId },
  });

  if (isError) {
    return (
      <div className="document-history-section document-history-section--error">
        <p className="document-history-section__error-message">
          Aktivitäten konnten nicht geladen werden.
        </p>
        <button
          type="button"
          className="document-history-section__retry"
          onClick={() => refetch()}
        >
          Erneut versuchen
        </button>
      </div>
    );
  }

  if (isLoading) {
    return (
      <div className="document-history-section document-history-section--loading">
        {Array.from({ length: SKELETON_ROWS }).map((_, i) => (
          <div
            key={i}
            data-testid="document-history-skeleton-row"
            className="document-history-section__skeleton-row"
          />
        ))}
      </div>
    );
  }

  return (
    <div className="document-history-section">
      <AuditLogTable entries={entries} emptyMessage="Keine Aktivitäten" />
    </div>
  );
};

export default DocumentHistorySection;
